import moment from "moment";

export const groupSchedulesByWeeks = (scheduledDates) => {

    if(!scheduledDates){
        return {startDate: null, endDate: null, schedulePlan: []}
    }

    const momentDates = scheduledDates.map( d => moment(d));

      //Group all dates by weeks
      const weekGroups = momentDates.reduce((acc, date) => {
        // create a composed key: 'year-week'
        const yearWeek = `${date.year()}-${date.week()}`;

        // console.log(yearWeek);

        // add this key as a property to the result object
        if (!acc[yearWeek]) {
          acc[yearWeek] = [];
        }
        // push the current date that belongs to the year-week calculated befor
        acc[yearWeek].push(date);
        return acc;
      }, {});

      const schedulePlan = [];
      for (var week in weekGroups) {
        const dates = weekGroups[week];
        const plan = { week, dates, topics: [] };
        schedulePlan.push(plan);
      }

      //Find max date
      var maxDate = new Date(Math.max.apply(null, momentDates));
      var minDate = new Date(Math.min.apply(null, momentDates));

      return { startDate: minDate, endDate: maxDate, schedulePlan }
}